import { render, staticRenderFns } from "./cmp-checkBox.vue?vue&type=template&id=09bf59c6&scoped=true"
import script from "./cmp-checkBox.vue?vue&type=script&lang=js"
export * from "./cmp-checkBox.vue?vue&type=script&lang=js"
import style0 from "./cmp-checkBox.vue?vue&type=style&index=0&id=09bf59c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf59c6",
  null
  
)

export default component.exports